export const types = {
  CHANGE_PERSONAS_EDIT_MODE: 'CHANGE_PERSONAS_EDIT_MODE',
  REMOVE_PERSONA_FROM_ORGANIZATION: 'REMOVE_PERSONA_FROM_ORGANIZATION',
  SET_ORGANIZATION_PERSONAS: 'SET_ORGANIZATION_PERSONAS',
  UPDATE_ORGANIZATION_PERSONAS: 'UPDATE_ORGANIZATION_PERSONAS',
};
